module.exports = __webpack_public_path__ + "static/media/search-location.df505625.svg";